import { IGcpAppDispatch } from "../../../redux/store";
import { toggleSatelliteMap } from "../../../redux/modules/worldLayer/reducer";
import { getWorldLayerState, IStoreState } from "../../../redux/rootReducer";
import { IGcpAppIo } from "../../../redux/io";
import {
  OSM_MAP_SELECTED,
  SATELLITE_MAP_SELECTED,
} from "../../../tracking/constants";

export const userClicksSatelliteMapButton =
  () =>
  async (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { trackAction }: IGcpAppIo,
  ) => {
    const worldLayerState = getWorldLayerState(getState());
    trackAction(
      worldLayerState.satelliteLayerIsOn
        ? OSM_MAP_SELECTED
        : SATELLITE_MAP_SELECTED,
    );
    dispatch(toggleSatelliteMap());
  };
